export const setAppResponsiveZoom = (pathname: string): void => {
	const useNativeZoom =
		pathname.includes("pointofsale") || /^\/orders\/?$/i.test(pathname);
	document.body.classList.toggle("no-zoom", useNativeZoom);
	document.body.classList.toggle("responsive-zoom", !useNativeZoom);
};
